# Contact people

You need to provide a [contact person] when [creating a position opening] or using the [`postPosition` mutation].
SEEK may reach out to them if there is a problem with their job ad after it’s gone live.
If the contact person has a recruiter profile, this information will be used to display their profile widget on the job ad.
If the contact person does not have a recruiter profile, the content of this field will not be shown on the job ad or exposed to candidates.
The following messaging may be presented to the user to explain SEEK’s usage of contact information:

> If you have a recruiter profile, your information may be displayed on the job ad.
> Otherwise, this information will only be visible to SEEK and will not be made public or displayed on the ad.

Multiple contact people can be provided in the [`personContacts` array].
This can be useful if the person recruiting for the position is different from the position’s hiring manager.
The [contact’s role] is used to differentiate those two cases.

At a minimum the person’s name, email & role must be provided.
You can automatically map or pre-fill these fields based on the user logged in to your software.
Note that physical addresses and phone numbers may be omitted,
and [`seekDoNotContactIndicator`] should be omitted as it is not supported for contact people.

```jsonc inputType="SpecifiedPersonInput" label="SpecifiedPersonInput"
// `positionOpening.postingRequester.personContacts[]`
{
  "name": {
    "formattedName": "Mary Manager"
  },
  "communication": {
    "email": [{ "address": "mary.manager@example.com" }],
    // This can be set to an empty array.
    "phone": [],
    // This can be omitted or set to an empty array.
    "address": [],
    // This should be omitted or set to null.
    "seekDoNotContactIndicator": null
  },
  "roleCode": "HiringManager"
}
```

The job ad is also attributed to their name in [SEEK Analytics]:

import { SeekAnalytics } from './SeekAnalytics';

<SeekAnalytics />

[`personcontacts` array]: /schema/named-type/PostingRequesterInput#/field/personContacts
[`postposition` mutation]: /use-cases/job-posting/managing-job-ads/posting-a-job-ad#postposition
[`seekdonotcontactindicator`]: /schema/named-type/CommunicationInput#/field/seekDoNotContactIndicator
[contact person]: /schema/named-type/SpecifiedPersonInput
[contact’s role]: /schema/named-type/SpecifiedPersonInput#/field/roleCode
[creating a position opening]: /use-cases/job-posting/position-openings#createpositionopening
[seek analytics]: https://au.employer.seek.com/analytics/ad-usage
